import './main.css';

function Main(props) {
  return (
    <>
        <div className="section">
            <div className="section__info">
                <p>{props.intro}</p>
            </div>
            <div className="bg-grey">
                <h1>{props.faqs.title}</h1>
                {props.faqs.questions.map((faq, index) => (
                    <div key={index}>
                        <h2>{faq.question}</h2>
                        <p>{faq.answer}</p>
                    </div>
                ))}
            </div>
            <p>FP724R3MAY23 <a className="btn" href="https://www.ageco.co.uk/">Go to Age Co website</a></p>
        </div>
    </>
  );
}

export default Main;
